'use strict';

var _ = require('lodash');
var e = {
  'FLEXIBLE_NO_CHARGE': 'Flexible (No Charge)',
  'FLEXIBLE_FEE': 'Flexible (fee)',
  'STRICT': 'Strict'
};

Object.defineProperty(e, 'ALL', { value: _.values(e) });
module.exports = e;